import axios from "axios";
import { constants } from "../context/constants";

const axiosInstance = axios.create({
    baseURL: constants.API_URL
});

export const withSessionAuthorization = (request, storage = localStorage) => {
    const token = storage.getItem('token');
    if (token && !request.headers?.Authorization) {
        request.headers = request.headers || {};
        request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
};

axiosInstance.interceptors.request.use(
    (request) => withSessionAuthorization(request),
    (error) => Promise.reject(error)
);

export default axiosInstance;
